var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEditIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.83343H2.16667C1.72464 3.83343 1.30072 4.00903 0.988155 4.32159C0.675595 4.63415 0.5 5.05807 0.5 5.5001V13.0001C0.5 13.4421 0.675595 13.8661 0.988155 14.1786C1.30072 14.4912 1.72464 14.6668 2.16667 14.6668H9.66667C10.1087 14.6668 10.5326 14.4912 10.8452 14.1786C11.1577 13.8661 11.3333 13.4421 11.3333 13.0001V12.1668M10.5 2.16677L13 4.66677M14.1542 3.48759C14.4824 3.15938 14.6668 2.71424 14.6668 2.25009C14.6668 1.78594 14.4824 1.34079 14.1542 1.01259C13.826 0.684384 13.3808 0.5 12.9167 0.5C12.4525 0.5 12.0074 0.684384 11.6792 1.01259L4.66667 8.00009V10.5001H7.16667L14.1542 3.48759Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconMobile);
export default __webpack_public_path__ + "static/media/edit-icon-mobile.43c16214b4c79acba01a29371b1990a6.svg";
export { ForwardRef as ReactComponent };